import { EClickPosition } from 'shared/constant';
import { SyntheticEvent, useCallback } from 'react';
import { sendClickEvent } from '~/utils/event';
import { useSetAtom } from 'jotai';
import { $CTAModal } from '~/components/cta-modal';

interface IUseCTADirectlyProps {
  clickPosition: EClickPosition;
  clickId?: string;
  onClick: () => void;
}

type TCTADirectly = (e?: SyntheticEvent) => void;

export const useCTADirectly = (props: IUseCTADirectlyProps): TCTADirectly => {
  const { clickPosition, clickId, onClick } = props;

  return useCallback(
    (e?: SyntheticEvent) => {
      // 1. prevent default event behaviour
      e?.preventDefault();

      // 2. click position
      sendClickEvent({
        clickPosition,
        clickId,
      });

      // 3. call click
      onClick();
    },
    [clickPosition, clickId, onClick],
  );
};

interface IUseCTADirectlyCallbackProps<P> {
  clickPosition: (params: P) => EClickPosition;
  clickId?: (params: P) => string;
  onClick: (params: P) => void;
}

type TCTADirectlyCallback<P> = (params: P) => (e?: SyntheticEvent) => void;

export const useCTADirectlyCallback = <P>(props: IUseCTADirectlyCallbackProps<P>): TCTADirectlyCallback<P> => {
  const { clickPosition, clickId, onClick } = props;

  const setCTAModal = useSetAtom($CTAModal);

  return useCallback(
    (params: P) => (e?: SyntheticEvent) => {
      // 1. prevent default event behaviour
      e?.preventDefault();

      // 2. click position
      sendClickEvent({
        clickPosition: clickPosition(params),
        clickId: clickId?.(params),
      });

      // 3. call on click
      onClick(params);
    },
    [clickPosition, clickId, onClick, setCTAModal],
  );
};
